import React, { createContext, useContext } from "react";
import { pl } from "./pl";

export type TranslationKey = keyof typeof pl;

// Register future languages here, e.g. { pl, en }.
const dictionaries: Record<string, Record<TranslationKey, string>> = { pl };

const resolveLanguage = (): string => {
  const lang = (navigator.language || "pl").slice(0, 2);
  return dictionaries[lang] ? lang : "pl";
};

const I18nContext = createContext<{ t: (key: TranslationKey) => string }>({
  t: (key) => pl[key],
});

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dict = dictionaries[resolveLanguage()];
  return (
    <I18nContext.Provider
      value={{ t: (key) => dict[key] ?? pl[key] ?? key }}
    >
      {children}
    </I18nContext.Provider>
  );
};

export const useT = () => useContext(I18nContext).t;
